// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2uif3","label":"styles_label__2_Lip"};